export default "__VITE_ASSET__ffabe072__"